import axios from "axios";
import { host, port, path, version } from "../systemVariables"

// Method path
const resource = "/vmslotposition";


export const LIST_VMSLOTPOSITION  = 'LIST_VMSLOTPOSITION';
export const ERROR = 'ERROR';

export function listVmSlotPosition(){
  return (dispatch) => {
    axios.get(host+ port + path  + version + resource,{
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Bearer " + sessionStorage.getItem("access_token"),
      }
    })
    .then((response) => {
      dispatch( { type: LIST_VMSLOTPOSITION, payload: response.data.data } );
    })
    .catch(function (error){
      dispatch( { type: ERROR, payload: error } );
    });
  }
}